<ng-container [ngSwitch]="admincolors">
  <div [ngClass]="admincolors ? 'headerMainAdmin' : 'headerMain'" class="sidebar-wrapper ps">

    <div class="logoCol" [ngStyle]="{'background-image': 'url(/assets/img/logo-squirrel-klein.png)'}">
    </div>

    <div class="environmentCol">
      <!-- <div class="logo">
        <div *ngIf="tenantImage" class="logo-img">
          <img [src]="tenantImage" alt="Mandanten Bild" style="margin-top: 10px; margin-right: 10px; max-width: 108px;">
        </div>
      </div> -->
      <div class="breadcrumbCol" *ngIf="breadcrumbs.length">
        <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
          <span class="crumb" [class.crumb-clickable]="crumb.path && !last" (click)="onBreadcrumbClick(crumb, last)">{{ crumb.label }}</span>
          <span *ngIf="!last" class="crumb-separator">&#8250;</span>
        </ng-container>
      </div>
      <p class="clickable"></p>
    </div>

<!-- <div class="legacyCol" >
    <p class="clickable">
    </p>
  </div> -->

  <!-- <div class="logo">
    <div *ngIf="tenantImage" class="logo-img">
        <img [src]="tenantImage" alt="Mandanten Bild"   style="margin-top: 10px; max-width: 108px; /*max-height: 58px; min-height: 60px;*/">
    </div>
  </div>   -->
      
    <!-- <div class="tenantCol" *ngIf="tenantName">
      <p class="clickable" title="Mandanten wechseln"
         [routerLink]="['/', 'select-tenant']"
         (click)="selectTenant()">
        <i class="material-icons">work</i>
        {{tenantName}}
      </p>
    </div> -->

    <div class="userCol">
      <p class="clickable abbrev" title="Benutzer" href="javascript:void(0)" [mat-menu-trigger-for]="menu">
        <i class="material-icons">person</i><span>{{username}}</span>
      </p>
      <span aria-haspopup="true" aria-expanded="false" style="color: #303f6f;"></span>
    </div>

  </div>
</ng-container>

<mat-menu #menu="matMenu">
  <ng-container *ngFor="let item of items">
    @if (item.text === 'USERPROFILE') {
      <a class="blueLetters dropdown-item {{item.icon}}" (click)="openUserProfileDialog()">
        {{this.translate.data[item.text] | translate}}
      </a>
    } @else if (item.text === 'CHANGEPSWD') {
      <a class="blueLetters dropdown-item {{item.icon}}" (click)="openChangePasswordDialog()">
        {{this.translate.data[item.text] | translate}}
      </a>
    } @else {
      <a class="blueLetters dropdown-item {{item.icon}}" [routerLink]="[item.path]">
        {{this.translate.data[item.text] | translate}}
      </a>
    }
  </ng-container>
  <a class="blueLetters" *ngFor="let info of userInfos" class="dropdown-item">
    {{this.translate.data[info.label] | translate}} {{tenantname}}
  </a>
</mat-menu>
